import { jsx as a } from "react/jsx-runtime";
import { forwardRef as m, useMemo as l } from "react";
import { TreeItem2 as c } from "@mui/x-tree-view/TreeItem2";
import p from "styled-components";
const d = {
  root: "treeItemRoot",
  group: "treeItemGroup",
  content: "treeItemContent",
  label: "treeItemLabel",
  iconContainer: "treeItemIconContainer",
  expanded: "treeItemExpanded",
  selected: "treeItemSelected",
  disabled: "treeItemDisabled",
  focused: "treeItemFocused"
}, s = p(c).withConfig({
  displayName: "StyledTreeItem"
})([
  "&.treeItemRoot{width:auto;min-width:100%;display:inline-flex;position:relative;font-family:",
  ";font-size:",
  ";color:",
  ";background-color:",
  ";box-sizing:border-box;flex-direction:column;& .treeItemGroup{margin-left:20px;width:auto;min-width:calc(100% - 20px);box-sizing:border-box;}& .treeItemGroup .MuiCollapse-wrapperInner{width:auto;min-width:100%;}& > .treeItemContent{height:24px;width:auto;margin:2px 8px;border-radius:4px;padding:0px 8px;gap:0px;}& > .treeItemContent::before{content:'';height:24px;width:100%;position:absolute;left:0px;border-radius:4px;}&&&:focus > .treeItemContent::before,& > .treeItemContent:hover::before{background-color:",
  ";}&&&:focus > .treeItemContent,&&& > .treeItemContent:hover{color:",
  ";}&&&:focus > .treeItemContent > .treeItemLabel,&&& > .treeItemContent:hover > .treeItemLabel{background-color:transparent;color:inherit;}&&&:focus > .treeItemContent > .treeItemIconContainer svg,&&& > .treeItemContent:hover > .treeItemIconContainer svg{color:inherit;}&&& > .treeItemContent > .treeItemLabel{height:100%;display:flex;flex-direction:column;justify-content:center;color:",
  ";user-select:none;padding:0px;flex:1;width:auto;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;}&&& > .treeItemContent > .treeItemIconContainer{width:16px;position:relative;margin:0px;& > .treeIconWrapper{width:16px;display:flex;align-items:center;}& svg{height:9px;width:9px;flex-shrink:0;margin:0px 0px 2px 0px;}}&&& > .treeItemSelected.treeItemContent,&&& > .treeItemFocused.treeItemContent{color:",
  ";outline:none;}& > .treeItemSelected.treeItemContent::before{background-color:",
  ";}& > .treeItemFocused.treeItemContent::before{background-color:",
  ";}&&& > .treeItemSelected.treeItemContent > .treeItemIconContainer svg,&&& > .treeItemFocused.treeItemContent > .treeItemIconContainer svg{color:inherit;}&&&:focus > .treeItemContent > .treeItemLabel,&&& > .treeItemSelected.treeItemContent > .treeItemLabel,&&& > .treeItemFocused.treeItemContent > .treeItemLabel{background-color:transparent;color:",
  ";outline:none;}&&&:focus > .treeItemContent{outline:none;}}"
], ({ theme: e }) => e.typography.fontFamily, ({ theme: e }) => e.typography.body200.fontSize, ({ theme: e }) => e.isLightTheme ? e.primaryBackground : e.text.primary, ({ theme: e }) => e.primaryBackground, ({ theme: e }) => e.primaryHover, ({ theme: e }) => e.isLightTheme ? e.primaryBackground : e.text.primary, ({ theme: e }) => e.isLightTheme ? e.colors.blue600 : e.text.primary, ({ theme: e }) => e.isLightTheme ? e.primaryBackground : e.text.primary, ({ theme: e }) => e.primaryFill, ({ theme: e }) => e.primaryHover, ({ theme: e }) => e.isLightTheme ? e.primaryBackground : e.text.primary), g = /* @__PURE__ */ m(({ alternateBackground: e = !1, children: r, classes: t, ...o }, n) => {
  const i = l(() => ({
    ...d,
    ...t
  }), [
    t
  ]);
  return /* @__PURE__ */ a(s, {
    classes: i,
    ref: n,
    $alternateBackground: e,
    ...o,
    children: r
  });
});
export {
  g as default
};
